export const educationData = {
  school: "Kalinga Institute of Industrial Technology",
  degree: "B.Tech in Computer Science & Engineering",
  location: "Bhubaneswar, India",
  year: "2019 - 2023",
  schooling: {
    school: "Modern Indian School",
    location: "Chobhar, Kathmandu",
    year: "2006 - 2019",
  },
};